import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAdminsList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/admins', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAdmin(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/auth/admins/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchRolesList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/roles', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
